import { GETROLES } from "../../common/constants/endpoints";
import API from "../../helpers/API";
import { GET_ALL_ROLES } from "../../common/constants/ActionTypes";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const getDashboardsUserListData = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(GETROLES, {
        headers: { Authorization: `Bearer ${token}` },
      });

      dispatch({
        type: GET_ALL_ROLES,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};
